import { SvgIcon } from '../Icon';
import { theme } from '../../styles/theme';
import React from 'react';

// XXX Special style/typography words (Kubit and Lumos respectively)
import { ReactComponent as KubitWordmark } from '../../assets/images/kubit-wordmark.svg';
import { ReactComponent as LumosWordmark } from '../../assets/images/lumos-wordmark.svg';
import styled from 'styled-components';

interface IProps {
  includeKubit?: boolean;
}

const Wrapper = styled.div<{ $includeKubit: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ $includeKubit }) => ($includeKubit ? 5 : 8)}px;
`;

const LumosIconAndWordmark = ({ includeKubit = false }: IProps) => {
  return (
    <Wrapper $includeKubit={includeKubit}>
      <SvgIcon
        height={16}
        width={16}
        name="lumos"
        customFill={theme.colors.purple500}
      />
      {includeKubit && (
        <KubitWordmark
          width={54}
          height={16}
          fill={theme.colors.secondary900}
        />
      )}
      <LumosWordmark fill={theme.colors.purple500} />
    </Wrapper>
  );
};

export default LumosIconAndWordmark;
